angular.module('bb.answering').factory('AnsweringService', AnsweringService);

AnsweringService.$inject = ['$resource'];

function AnsweringService($resource) {
  // Resources
  const ResourceLoader = $resource('/answering/appointments/:page', {
    page: '@page',
  });
  const AppointmentFlag = $resource('/appointments/:appointmentId/flag', {
    appointmentId: '@appointmentId',
  });
  const CentralizedQueuePreferencesState = $resource(
    '/answering/queue_preferences/state',
  );
  const Appointment = $resource('/appointments/:appointmentId', {
    appointmentId: '@appointmentId',
  });
  const MlsTypes = $resource('/answering/mls_types');

  // Functions
  const getAppointment = appointmentId =>
    Appointment.get({ appointmentId }).$promise;

  const flagAppointment = (appointmentId, flagged) =>
    AppointmentFlag.save({ appointmentId, flagged }).$promise;

  const loadResource = options => ResourceLoader.get(options).$promise;

  const getCentralizedQueuePreferencesState = () =>
    CentralizedQueuePreferencesState.get().$promise;

  const getMlsTypes = () => MlsTypes.query().$promise;

  return {
    getAppointment,
    flagAppointment,
    loadResource,
    getCentralizedQueuePreferencesState,
    getMlsTypes,
  };
}

export {};
